import { create } from "zustand";
import { loadGIFSound, setGIFSound } from "@/common/utils/storage";

interface IAppState {
  // initial state
  isBurgerMenuOpen: boolean;
  isProfileMenuOpen: boolean;
  isSearchBarOpen: boolean;
  gifSound: boolean;
  isFullScreen: boolean;

  // actions
  toggleBurgerMenu: () => void;
  toggleProfileMenu: () => void;
  toggleGifSound: (gifSound: boolean) => void;
  toggleFullScreen: (isFullScreen: boolean) => void;
  hideAllMenus: () => void;
  openSearch: () => void;
  closeSearch: () => void;
}

export const useAppStore = create<IAppState>(
  (set) => ({
    // initial state
    isBurgerMenuOpen: false,
    isProfileMenuOpen: false,
    isSearchBarOpen: false,
    gifSound: loadGIFSound(),
    isFullScreen: false,

    // actions
    toggleBurgerMenu: () => set((state) => ({ isBurgerMenuOpen: !state.isBurgerMenuOpen })),
    toggleProfileMenu: () => set((state) => ({ isProfileMenuOpen: !state.isProfileMenuOpen })),
    openSearch: () => set({ isSearchBarOpen: true }),
    closeSearch: () => set({ isSearchBarOpen: false }),
    toggleGifSound: (gifSound: boolean) => set(() => {
      setGIFSound(JSON.stringify(gifSound));
      return { gifSound };
    }),
    toggleFullScreen: (isFullScreen: boolean) => set(() => ({ isFullScreen })),
    hideAllMenus: () => set(() => ({
      isSearchBarOpen: false,
      isBurgerMenuOpen: false,
      isProfileMenuOpen: false,
    })),
  }),
);
